export enum OrgsActionTypes {
  RETRIEVE_RELEVANT_ORGS = '@@orgs/RETRIEVE_RELEVANT_ORGS',
  RETRIEVE_RELEVANT_ORGS_SUCCESS = '@@orgs/RETRIEVE_RELEVANT_ORGS_SUCCESS',
}
